<script setup lang="ts">
    import type { HTMLAttributes } from 'vue';
    import { cn } from '@/lib/utils';

    const props = defineProps<{
        class?: HTMLAttributes['class'];
    }>();
</script>

<template>
    <th
        data-slot="table-head"
        :class="
            cn(
                'sticky z-20 h-10 bg-white px-2 text-left align-middle text-xs font-semibold whitespace-nowrap first:rounded-tl last:rounded-tr [&:has([role=checkbox])]:pr-0 [&>[role=checkbox]]:translate-y-[2px]',
                props.class,
            )
        "
    >
        <slot />
    </th>
</template>
